module.exports = __webpack_public_path__ + "static/media/medium.b92c02ad.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/medium.png
// module id = 65
// module chunks = 0